<script lang="ts">
	import Avatar from '$lib/components/Avatar/Avatar.svelte';

	export let mentionsUserStore: Array<{
		id: string;
		type: string;
		name: string;
		avatar_url: string;
	}> = [];

	export let selectedIndex = 0;

	export let submitChoice: () => void;

	$: {
		mentionsUserStore;
		selectedIndex = 0;
	}
</script>

{#if mentionsUserStore.length > 0}
	<div class="users">
		<ul>
			{#each mentionsUserStore as user, i (user.id)}
				<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
				<li
					class:selected={i === selectedIndex}
					class="user"
					on:focus={null}
					on:keydown={null}
					on:mouseover={() => {
						selectedIndex = i;
					}}
					on:click={() => {
						selectedIndex = i;
						submitChoice();
					}}>
					<Avatar size={28} url={user.avatar_url} name={user.name} />
					<h3>{user.name}</h3>
				</li>
			{/each}
		</ul>
	</div>
{/if}

<style>
	.users {
		display: flex;
		inline-size: 360px;
		background-color: white !important;
		box-shadow: rgb(0 0 0 / 20%) 0 1px 8px;
		border-start-start-radius: 2px;
		border-start-end-radius: 2px;
		border-end-end-radius: 2px;
		border-end-start-radius: 2px;
	}

	.users ul {
		inline-size: 100%;
	}

	.user {
		display: flex;
		align-items: center;
		block-size: 36px;
		padding-inline: var(--gutterSmall);
		background-color: white;
		cursor: pointer;
		border-block-end: 1px solid rgb(238 238 238);
	}

	.user h3 {
		margin-inline-start: var(--gutterSmall);
	}

	.selected {
		background-color: #408cea;
	}

	.selected h3 {
		color: white;
	}
</style>
